export default {
    filter: {
        query: '',
    },
    isloadingProducts: false,  
    orderBy: 'alfabetico',
    productDetail: null,       
    products: [],
    relatedProducts: [],
}